import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import Layout from '../components/Layout'

import Home from "../pages/outros/templates/Home";
import Perfil from "../pages/configuracoes/Perfil/Perfil";
import PerfilNovo from "../pages/configuracoes/Perfil/PerfilNovo";
import Usuario from "../pages/configuracoes/Usuario/Usuario";
import UsuarioNovo from "../pages/configuracoes/Usuario/UsuarioNovo";
import Instituiticao from "../pages/configuracoes/Instituiticao/Instituiticao";
import InstituiticaoNovo from "../pages/configuracoes/Instituiticao/InstituiticaoNovo";
import Cliente from "../pages/cadastros/Cliente/Cliente";
import ClienteNovo from "../pages/cadastros/Cliente/ClienteNovo";
import Gerencial from "../pages/dashboards/Gerencial";
import Relatorios from "../pages/configuracoes/Relatorios/Relatorios";


function DetailRoute({ component: Component, ...rest }) {
  return (
    <Route
      {...rest}
      render={(routeProps) => (
        <Component {...routeProps} />
      )}
    />
  );
}

const AppRoutes = () => (
  <Layout >
    <div className="content-wrapper">
      <Switch>
        <Route exact path="/" component={Gerencial} />
        <Route exact path="/home" component={Home} />
        <Route exact path="/profile" component={Perfil} />
        <Route exact path="/user" component={Usuario} />
        <Route exact path="/instituition" component={Instituiticao} />
        <Route exact path="/customer" component={Cliente} />
        <Route exact path="/reports" component={Relatorios} />
        <DetailRoute exact path="/profile/profile-new" component={PerfilNovo} />
        <DetailRoute exact path="/profile/profile-edit/:id" component={PerfilNovo} />
        <DetailRoute exact path="/user/user-edit/:id" component={UsuarioNovo} />
        <DetailRoute exact path="/user/user-new" component={UsuarioNovo} />
        <DetailRoute exact path="/instituition/instituition-edit/:id" component={InstituiticaoNovo} />
        <DetailRoute exact path="/instituition/instituition-new" component={InstituiticaoNovo} />
        <DetailRoute exact path="/customer/customer-new" component={ClienteNovo} />
        <DetailRoute exact path="/customer/customer-edit/:id" component={ClienteNovo} />
        <Redirect from="*" to="/" />
      </Switch>
    </div>
  </Layout>
);

export default AppRoutes;
